import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/auth";
import { Link } from "react-router-dom";

import NotFound from "../shared/404";

const VidAgencykitai = () => {
  const dispatch = useDispatch();
  const access = useSelector((state) => state.auth.access);

  const subdomain_name = useSelector(state => state.auth.product.subdomain_name)

  useEffect(() => {
    document.title = `${subdomain_name ? subdomain_name : 'Engageleads'} | MasterClass`;
  },[subdomain_name]);

  useEffect(() => {
    dispatch(authActions.setLoaderStatus({ status: false }));
  });

  const meta_data = useSelector(state => state.auth.product.meta_data)
  const logo = meta_data && JSON.parse(meta_data).subdomainLogo ? JSON.parse(meta_data).subdomainLogo : `${process.env.PUBLIC_URL}/newlogo.png`;


  const MasterPage = () => {
    return (
      <section className="mid_wrap">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-4 pb-2">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
              VidAgencyKit AI
              </li>
            </ol>
          </nav>
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="bx_a">
                <div className="emptyDiv">
                  <img
                      src={logo}
                      alt="img"
                      className="mt-4"
                    />
                    <br />
                    <div className="p-5 pt-3 text-center">
                      <h4 >
                      VidAgencyKit AI
                      </h4>
                    </div>
                    
                    <a href="https://register.gotowebinar.com/register/6891259924450217309" className="btn btn-primary d-none" target="_blank" rel="noreferrer">Join {subdomain_name} Masterclass Session 1</a>
                    <br />
                </div>
              </div>
            </div>
          </div>
          <div className="row my-5">
            <div className="col-md-12 my-5"></div>
          </div>
        </div>
      </section>
    );
  };
  return (
    <>
      {  access.includes("5") || access.includes("6A") || access.includes("1a") ||access.includes("8A") ? (
        <MasterPage />
      ) : (
        <NotFound />
      )}
    </>
  );
};

export default VidAgencykitai;
